<div class="container" [ngClass]="{'without-line-title-bar': withoutLine}">
    <div *ngIf="backLink" (click)="navigateToBack(backLink)" class="arrow-back clickable">
        <ion-icon name="chevron-back"></ion-icon>
    </div>
    <div *ngIf="!withoutLine" class="line" [ngStyle]="{'background': lineColor}"></div>
    <div *ngIf="pointedFrame" class="border" [ngStyle]="{'background': lineColor}"></div>
    <div
        *ngIf="pointedFrame" 
        class="background" 
        [ngClass]="{'background-black-pattern': blackPattern, 'background-sweepstakes': sweepstakes, 'background-freeplay': freeplay, 'background-social': social, 'background-club': clubList}" 
        [ngStyle]="{'background' : getBackgroundGradient()}">
    </div>
    <div class="title-wrapper" *ngIf="title">
        <img [class]="{'social-title-image': social}" *ngIf="image" [src]="image">
        <div class="title" [ngStyle]="additionalTitleStyle" [ngClass]="{'small-font': smallFontSize, 'uppercase': uppercase, 'social-title': social}">{{title}}</div>
    </div>
    <div *ngIf="(sweepstakes || freeplay) && isSweepBuckOn && !goldJackpot && !sweepsWaitingJackpot" class="image-title-wrapper">
        <img class="money" src="{{ freeplay ? 'assets/icon/chips/gold_chip.webp' : 'assets/img/sweep/money.webp' }}" alt="money">
        <img class="logo" src="{{ sweepstakes ? 'assets/img/sweep/social_sweepstakes_logo.webp' : '/assets/img/homepage/free-play/freeplay_gold_sopo_logo.webp' }}" alt="logo">
        <img class="money" src="{{ freeplay ? 'assets/icon/chips/gold_chip.webp' : 'assets/img/sweep/money.webp' }}" alt="money">
    </div>
    <div *ngIf="goldJackpot && !sweepsWaitingJackpot" class="image-title-wrapper">
        <img class="logo" src="/assets/img/homepage/free-play/freeplay_gold_sopo_logo.webp" alt="logo">
    </div>
    <div *ngIf="sweepsWaitingJackpot" class="sweeps-waiting-image-title-wrapper">
        <img class="logo" src="../../../../assets/img/sweep/sopo-logo-sweepstakes.webp" alt="logo">
    </div>
    <div *ngIf="freeplay && !isSweepBuckOn" class="freeplay-image-title-wrapper">
        <img class="logo" src="/assets/img/homepage/free-play/freeplay_gold_sopo_logo.webp" alt="logo">
    </div>
    <div class="image-title-wrapper" *ngIf="clubList">
        <img class="logo" src="assets/img/lobby/club_lobby_title_image.webp" alt="club-list-logo"/>
    </div>
</div>
